import { apiWrapper } from 'apis/CommonApi';
import Pagenation from 'components/Pagenation';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from 'utils/store';
import * as fireonApi from '../../apis/FireOnApi';
import { dateFormat, getDate, getDateTime } from 'utils/date';

export default function FireInspectionScheduleComponent(props) {
    const { id } = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkedIds, setCheckedIds] = useState([]);
    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getFireFightingInspectionScheduleList(id);
            if (status === true) {
                setDataSource(data);
            } else {
                alert(`${data}`);
            }
        });
    }

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            setCheckedIds(dataSource.map((a) => a.id));
        } else {
            setCheckedIds([]);
        }
    };

    const handleChangeChecked = (e, id) => {
        if (e.target.checked) {
            setCheckedIds([...checkedIds, id]);
        } else {
            setCheckedIds(checkedIds.filter((a) => a !== id));
        }
    }

    const handleDelete = (e) => {
        if (window.confirm("삭제하시겠습니까?")) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.bulkDeleteFireFightingInspectionSchedule(checkedIds);
                alert(`${data}`)

                //삭제 성공 시 새로고침
                if (status === true) {
                    setCheckedIds([]);
                    getData();
                }
            });
        }
    }

    const openModal = () => {
        setIsModalOpen(true);
        setTimeout(() => {
            const modalContent = document.querySelector(".modal_content");
            if (modalContent) {
                modalContent.style.transform = "translateX(0)";
            }
        }, 10);
    };

    const closeModal = () => {
        const modalContent = document.querySelector(".modal_content");
        if (modalContent) {
            modalContent.style.transform = "translateX(100%)";
        }
        setTimeout(() => {
            setIsModalOpen(false);
        }, 500);
    };

    return (
        <>
            <div className="viewBoard fireOnBoard tableBoard schedeuleListBoard">
                {checkedIds.length > 0 && (
                    <div className="toolbar" style={{ display: 'block' }}>
                        <div className="wrap_inner">
                            <button className="btn_tb btn_tbAdd" onClick={handleDelete}>선택 삭제</button>
                        </div>
                    </div>
                )}

                <TopBoard header={props.header} />
                <MidBoard openModal={openModal} />
                <TableBoard dataSource={dataSource} checkedIds={checkedIds} handleCheckAll={handleCheckAll} handleChangeChecked={handleChangeChecked} />
                {isModalOpen && <Modal closeModal={closeModal} getData={getData} />}
                <div id="pagination" className="mb">
                    <Pagenation />
                </div>
            </div>
        </>
    );
}

const TopBoard = ({ header }) => {
    const navigate = useNavigate();
    const { store: { userName } } = useAppContext();

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo"> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="">
                            <img src="/images/my_btn_mb_w.png" alt="" />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">소방설비점검 일정</p>
                </div>
                {header}
            </div>
        </>
    );
};

const MidBoard = ({ openModal }) => {
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    return (
        <div className="mid_board mid_col_board">
            <div className="wrap_mid_le">
                <p className="title_mid">{buildingName}</p>
            </div>
            <div className="wrap_right">
                <div className="wrap_item_contr">
                    <div className="building_info">
                        <div className="item_info">
                            <p className="txt_info title_info">일련번호</p>
                            <p className="txt_info code_info">{serialNumber}</p>
                        </div>
                        <div className="item_info">
                            <p className="txt_info title_info">DEI 코드</p>
                            <p className="txt_info code_info">{dei}</p>
                        </div>
                    </div>
                    <div className="wrap_right pc">
                        <div className="wrap_item_contr">
                            <button className="btn_contr btn_add" onClick={openModal}>
                                추가 <i className="x-icon"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TableBoard = ({ dataSource, checkedIds, handleCheckAll, handleChangeChecked }) => {
    return (
        <div className="table_board">
            <div className="wrap_table">
                <div className="containerTable schedeuleListTable">
                    <ul className="head_table">
                        <li><input className="all_chk" type="checkbox" onChange={handleCheckAll} /></li>
                        <li><p>등록 ID</p></li>
                        <li><p>등록 일시</p></li>
                        <li><p>등록자</p></li>
                        <li><p>점검사유</p></li>
                        <li><p>점검자</p></li>
                        <li><p>점검자 연락처</p></li>
                        <li><p>점검 시작일시</p></li>
                        <li><p>점검 종료일시</p></li>
                    </ul>
                    <div className="body_table">
                        <div className="inner_table_wrap">
                            {dataSource.length > 0 &&
                                dataSource.map((item, index) => (
                                    <TableRow
                                        registerId={item.id}
                                        createdAt={getDateTime(new Date(item.createdAt))}
                                        writer={item.writer}
                                        reason={item.reason}
                                        inspector={item.inspector}
                                        contact={item.contact}
                                        startDate={getDateTime(new Date(item.startDate))}
                                        endDate={getDateTime(new Date(item.endDate))}
                                        checked={checkedIds.includes(item.id)}
                                        handleChangeChecked={handleChangeChecked}
                                    />
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TableRow = ({ registerId, createdAt, writer, reason, inspector, contact, startDate, endDate, checked, handleChangeChecked }) => {
    return (
        <div className="wrap_table_item">
            <div className="inner_table_item table_item_01">
                <input className="cont_table_chekbox" type="checkbox" checked={checked} onChange={(e) => handleChangeChecked(e, registerId)} />
            </div>
            <div className="inner_table_item table_item_02">
                <p className="cont_table_item">{registerId}</p>
            </div>
            <div className="inner_table_item table_item_03">
                <p className="cont_table_item">{createdAt}</p>
            </div>
            <div className="inner_table_item table_item_04">
                <p className="cont_table_item">{writer}</p>
            </div>
            <div className="inner_table_item table_item_05">
                <p className="cont_table_item">{reason}</p>
            </div>
            <div className="inner_table_item table_item_06">
                <p className="cont_table_item">{inspector}</p>
            </div>
            <div className="inner_table_item table_item_07">
                <p className="cont_table_item">{contact}</p>
            </div>
            <div className="inner_table_item table_item_08">
                <p className="cont_table_item">{startDate}</p>
            </div>
            <div className="inner_table_item table_item_09">
                <p className="cont_table_item">{endDate}</p>
            </div>
        </div>
    );
};

const Modal = ({ closeModal, getData }) => {
    const { id } = useParams();
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        setFormDataProperty("writer", "");
        setFormDataProperty("startDate", "");
        setFormDataProperty("startTime", "");
        setFormDataProperty("endDate", "");
        setFormDataProperty("endTime", "");
        setFormDataProperty("reason", "");
        setFormDataProperty("inspector", "");
        setFormDataProperty("contact", "");
    }, []);

    const setFormDataProperty = (name, value) => {
        setFormData((currentFormData) => {
            const nextFormData = {
                ...currentFormData,
                [name]: value,
            };
            //console.log(nextFormData);
            return nextFormData;
        });
    };

    const onChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormDataProperty(name, value);
    };

    const handleSave = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else if (checkValid() === false) {
            e.stopPropagation();
        } else {
            apiWrapper(async () => {
                const requestBody = {
                    writer: formData.writer,
                    startDate: new Date(`${formData.startDate} ${formData.startTime}`),
                    endDate: new Date(`${formData.endDate} ${formData.endTime}`),
                    reason: formData.reason,
                    inspector: formData.inspector,
                    contact: formData.contact,
                };
                let result;

                if (formData.id) {
                    result = await fireonApi.updateFireFightingInspectionSchedule(formData.id, requestBody);
                } else {
                    result = await fireonApi.createFireFightingInspectionSchedule(id, requestBody);
                }

                const { status, data } = result;
                alert(`${data}`);

                if (status === true) {
                    //성공 시 새로고침
                    closeModal();
                    getData();
                }
            });
        }
    }

    const checkValid = () => {
        return true;
    }

    return (
        <div id="modal" className="modal rightModal noticeRightModal open"
            onClick={(e) => {
                if (e.target === e.currentTarget)
                    closeModal();
            }}>
            <form className="modal_content" onSubmit={handleSave}>
                <button type="button" className="close_modal" onClick={closeModal}>
                    <i className="x-icon close_icon"></i>
                </button>
                <h2>소방설비점검 일정 등록</h2>
                {formData && (
                    <div className="wrap_detail_cont veiw_radio_cont">
                        <div className="wrap_detail_item default_type_item">
                            <p className="title_detail">등록자</p>
                            <div className="detail_box">
                                <input className="default_input" type="text" placeholder="등록자 성함을 작성해주세요." name="writer" value={formData.writer} onChange={onChange} required />
                            </div>
                        </div>
                        <div className="wrap_detail_item default_type_item">
                            <p className="title_detail">점검시작 일시</p>
                            <div className="detail_box detail_date_box">
                                <div className={`date-input-wrap ${formData.startDate ? "selected" : ""}`} onChange={onChange} required>
                                    <p class="date-title" style={{ display: formData.startDate ? "none" : "block" }}>{formData.startDate || '년-월-일'}</p>
                                    <input type="date" class="form-input" id="start_date" name="startDate" value={formData.startDate} />
                                </div>
                                <div
                                    className={`date-input-wrap ${formData.startTime ? "selected" : ""}`} >
                                    <p className="date-title" style={{ display: formData.startTime ? "none" : "block" }}>{formData.startTime || '시간'}</p>
                                    <input type="time" className={`form-input ${formData.startTime ? "selected" : ""}`} id="time" name="startTime" value={formData.startTime} onChange={onChange} />
                                </div>
                            </div>
                        </div>
                        <div className="wrap_detail_item default_type_item">
                            <p className="title_detail">예상 점검종료 일시</p>
                            <div className="detail_box detail_date_box">
                                <div className={`date-input-wrap ${formData.endDate ? "selected" : ""}`} onChange={onChange} required>
                                    <p class="date-title" style={{ display: formData.endDate ? "none" : "block" }}>{formData.endDate || '년-월-일'}</p>
                                    <input type="date" class="form-input" id="end_date" name="endDate" value={formData.endDate} />
                                </div>
                                <div
                                    className={`date-input-wrap ${formData.endTime ? "selected" : ""}`} >
                                    <p className="date-title" style={{ display: formData.endTime ? "none" : "block" }}>{formData.endTime || '시간'}</p>
                                    <input type="time" className={`form-input ${formData.endTime ? "selected" : ""}`} id="time" name="endTime" value={formData.endTime} onChange={onChange} />
                                </div>
                            </div>
                        </div>
                        <div className="wrap_detail_item default_type_item textarea_type_item">
                            <p className="title_detail">점검사유</p>
                            <div className="detail_box">
                                <textarea className="detail_textarea h-148" placeholder="점검사유를 입력해주세요." name="reason" value={formData.reason} onChange={onChange} required ></textarea>
                            </div>
                        </div>
                        <div className="wrap_detail_item default_type_item">
                            <p className="title_detail">점검자</p>
                            <div className="detail_box">
                                <input className="default_input" type="text" placeholder="점검자 성함을 작성해주세요." name="inspector" value={formData.inspector} onChange={onChange} required />
                            </div>
                        </div>
                        <div className="wrap_detail_item default_type_item">
                            <p className="title_detail">연락처</p>
                            <div className="detail_box">
                                <input className="default_input" type="text" placeholder="연락처를 입력해주세요." name="contact" value={formData.contact} onChange={onChange} required />
                            </div>
                        </div>
                        <button type="submit" className="btn_dark">저장</button>
                    </div>
                )}
            </form>
        </div>
    );
};